document.addEventListener("DOMContentLoaded", function() {
    const rankMathTOC = document.getElementById("rank-math-toc");

    if (rankMathTOC) {
    const tocItems = rankMathTOC.querySelectorAll("p, h2");

    tocItems.forEach(function(tocItem) {
        tocItem.addEventListener("click", function(event) {
            event.preventDefault();
            this.classList.toggle("active");
            const nextElement = this.nextElementSibling;
            if (nextElement) {
            if (nextElement.style.display === "block") {
                nextElement.style.display = "none";
            } else {
                nextElement.style.display = "block";
            }
            }
        });
    });
    }
});